//store.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
//初始化时用sessionStore.getItem('token'),这样子刷新页面就无需重新登录
const state = {
  token: window.sessionStorage.getItem('token'),
  username: window.sessionStorage.getItem('username'),
  rolelevel: window.sessionStorage.getItem('rolelevel'),
  usercompanyid: window.sessionStorage.getItem('usercompanyid'),
  usermoudle: window.sessionStorage.getItem('usermoudle'),
  useraction: window.sessionStorage.getItem('useraction'),
  loginpath: window.sessionStorage.getItem('loginpath'),
};
const mutations = {
  LOGIN: (state, data) => {
    //更改token的值
    state.token = data
    window.sessionStorage.setItem('token', data)
  },
  LOGOUT: (state) => {
    //登出的时候要清除token
    state.token = null
    window.sessionStorage.removeItem('token')
    window.sessionStorage.removeItem('username')
    window.sessionStorage.removeItem('rolelevel')
    window.sessionStorage.removeItem('usercompanyid')
    window.sessionStorage.removeItem('usermoudle')
    window.sessionStorage.removeItem('useraction')
  },
  USERNAME: (state, data) => {
    //把用户名存起来
    state.username = data
    window.sessionStorage.setItem('username', data)
  },
  ROLELEVEL: (state, data) => {
    // 把用户的角色级别存起来
    state.rolelevel = data
    window.sessionStorage.setItem('rolelevel', data)
  },
  USERCOMPANYID: (state, data) => {
    state.usercompanyid = data
    window.sessionStorage.setItem('usercompanyid', data)
  },
  USERMOUDLE: (state, data) => {
    // 存储管辖公司后的可用模块列表
    state.usermoudle = data
    window.sessionStorage.setItem('usermoudle', JSON.stringify(data))
  },
  USERACTION: (state, data) => {
    // 存储管辖公司后的可用模块列表
    state.useraction = data
    window.sessionStorage.setItem('useraction', JSON.stringify(data))
  },
  LOGINPATH: (state, data) => {
    //存储登录时所用到的登录页面地址标识
    state.loginpath = data
    window.sessionStorage.setItem('loginpath', data)
  },

};
const actions = {
  UserLogin({
              commit
            }, data) {
    commit('LOGIN', data)
  },
  UserLogout({
               commit
             }) {
    commit('LOGOUT')
  },
  UserName({
             commit
           }, data) {
    commit('USERNAME', data)
  },
  RoleLevel({
              commit
            }, data) {
    commit('ROLELEVEL', data)
  },
  UserCompanyId({
                  commit
                }, data) {
    commit('USERCOMPANYID', data)
  },
  // 获取管辖公司之后得模块列表
  UserMoudle({
               commit
             }, data) {
    commit('USERMOUDLE', data)
  },
  UserAction({
               commit
             }, data) {
    commit('USERACTION', data)
  },
  LoginPath({
               commit
             }, data) {
    commit('LOGINPATH', data)
  },
};
export default new Vuex.Store({
  state,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/tool/store.js